export default "__VITE_PUBLIC_ASSET__f9b2468a__"